// ** test if a filename matches one of the regex expressions defined in the VALID_FILES_REGEX array
import { VALID_FILES_REGEX as regexRef } from "../Constant";

export const isValidFile = ({ name }: File) =>
  regexRef.some((r) => r.test(name));
